import { EnvVars } from './types';

const reactEnvPrefix: string = 'REACT_APP_';

// extract react-script env vars
export default Object.keys(process.env)
    .filter((key) => key.match(reactEnvPrefix))
    .reduce((variables, key: string) => {
        const env: string = key.split(reactEnvPrefix)[1];

        variables[env] = process.env[key];

        return variables;
    }, {}) as EnvVars;



// WEBPACK FOOTER //
// ./src/env.ts